import { useAuth0 } from '@auth0/auth0-react'

import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { Footer } from '../components/Footer'
import { MyPagesList } from '../components/MyPages'
import { Spinner } from '../components/Spinner'
import { TopLogo } from '../components/TopLogo'

const MyPages = (): JSX.Element => {
  const { isAuthenticated, isLoading } = useAuth0()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      history.replace(`/login/redirect/${encodeURIComponent(location.pathname)}`)
    }
  }, [isAuthenticated, isLoading, history, location])

  if (isLoading || !isAuthenticated) {
    return (
      <div id="page-root" className="relative h-screen overflow-auto">
        <TopLogo />
        <div className="flex min-h-[400px] justify-center items-center py-20">
          <Spinner size="lg" />
        </div>
      </div>
    )
  }

  return (
    <div id="page-root" className="relative h-screen overflow-auto">
      <TopLogo />

      <div className="mx-auto max-w-4xl px-4 py-8">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-graphite-grey mb-2 md:text-4xl">My Pages</h1>
          <p className="text-gray-600">View and manage all your claimed pages</p>
        </div>
        <MyPagesList />
      </div>

      <div className="mt-12">
        <Footer />
      </div>
    </div>
  )
}

export default MyPages
